// src/pages/MediaCoverage.js
import React, { useMemo } from "react";
import MEDIA_ARTICLES from "../data/mediaArticles";
import MediaArticleCard from "../components/MediaArticleCard";

export default function MediaCoverage() {
  // Optional: sort newest first
  const articles = useMemo(() => {
    return [...MEDIA_ARTICLES].sort((a, b) => {
      // If you don't have real dates, just return 0
      if (!a.date || !b.date) return 0;
      return new Date(b.date) - new Date(a.date);
    });
  }, []);

  return (
    <div className="grid gap-6">
      {/* Hero / intro section */}
      <section className="bg-slate-900/70 border border-slate-800 rounded-2xl px-5 py-5 md:px-6 md:py-6 shadow-sm shadow-emerald-500/10">
        <h1 className="text-3xl font-bold tracking-tight text-slate-50">
          Media &amp; Press Coverage
        </h1>

        <p className="mt-2 text-sm text-slate-300 max-w-2xl">
          We&apos;re grateful to everyone who&apos;s written about Kepithor,
          our games, and our partners. Below is a curated selection of articles
          and features from around the web.
        </p>

        <div className="mt-4 flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between">
          <p className="text-sm text-slate-400 max-w-xl">
            Are you a publisher, blogger, or creator who has covered us?{" "}<br></br>
            {/* <span className="text-slate-200 font-medium"> */}
              We&apos;d love to showcase your article here.<br></br>
            {/* </span>{" "} */}
            Send us the link and a short description so we can add you to this
            page.<br></br><br></br>
            mailto: team@kepithorstudios.com
          </p>

          <div className="flex flex-wrap gap-2">
            {/* TODO: Replace mailto / link with your real press / contact URL */}
            {/* <a
              href="mailto:press@yourdomain.com?subject=Kepithor%20Press%20Coverage"
              className="inline-flex items-center justify-center px-4 py-2 text-sm font-medium rounded-xl bg-emerald-500 text-slate-900 hover:bg-emerald-400 transition-colors"
            >
              Share your article
            </a> */}

            <a
              href="mailto:team@kepithorstudios.com?subject=Kepithor%20Press%20Coverage"
                className="inline-flex items-center justify-center px-4 py-2 text-sm font-medium rounded-xl bg-emerald-500 text-slate-900 hover:bg-emerald-400 transition-colors"
            >
              Contact our team
            </a>
            
            <a
              href="https://drive.google.com/drive/folders/1TUpaZosehIDdVCvXKw3E-KvLEkqEudtA?usp=sharing"
              className="inline-flex items-center justify-center px-4 py-2 text-sm font-medium rounded-xl border border-slate-600 text-slate-200 hover:bg-slate-700/40 transition-colors"
                target="_blank"
            >
              Media Pack
            </a>
          </div>
        </div>
      </section>

      {/* Articles grid */}
      {articles.length === 0 ? (
        <div className="text-sm text-slate-400">
          No media articles have been added yet. Check back soon!
        </div>
      ) : (
        <section className="grid gap-4">
          <h2 className="text-sm font-semibold uppercase tracking-[0.2em] text-slate-400">
            Featured coverage
          </h2>

          <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
            {articles.map((article) => (
              <MediaArticleCard key={article.id} article={article} />
            ))}
          </div>
        </section>
      )}

      <div className="spacer" style={{ height: 80 }} />
    </div>
  );
}
